import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PageEvent, MatPaginator } from '@angular/material/paginator';

import { CustomerProvider } from '../../../providers/customer/customer';
import { HelpersProvider } from '../../../providers/helpers/helpers';
import { I18nProvider } from '../../../providers/i18n/i18n';

import { environment } from '../../../environments/environment';

@Component({
  selector: 'dashboard-ranking',
  templateUrl: './ranking.html',
  styleUrls: ['./ranking.scss'],
})
export class DashboardRankingComponent implements OnInit {

  @Input() user: any;
  @ViewChild('paginator') paginator: MatPaginator;

  ENV: any = environment;
  STRINGS: any;

  loading: boolean = true;
  rankingEnabled: boolean = true;
  ranking: any = [];
  pageSize: number = 10;
  pageIndex: number = 0;
  length: number = 0;
  selectedPeriod: string = 'all';
  periodOptions: any = [
    { value: 'week', label: 'Semanal' },
    { value: 'month', label: 'Mensal' },
    { value: 'year', label: 'Anual' },
    { value: 'all', label: 'Todo o período' },
  ];

  constructor(
    public customerProv: CustomerProvider,
    public helpers: HelpersProvider,
    public i18n: I18nProvider,
    private router: Router,
  ) {
    this.STRINGS = this.i18n.translate();
  }

  ngOnInit() {
    this.getRanking();
  }

  getRanking(force: boolean = false, pageIndex: number = this.pageIndex) {
    this.loading = true;
    this.pageIndex = pageIndex;
    const cacheName = this.cacheName();

    this.helpers.getCacheDB(cacheName).then(
      (cache: any) => {
        if (cache === undefined || cache === null || force) {
          this.customerProv.admGetRanking({
            limit: this.pageSize,
            offset: this.pageIndex * this.pageSize,
            metric: 'points',
            period: this.selectedPeriod,
          }).then(
            (res: any) => {
              this.helpers.addCacheDB(cacheName, res);
              this.applyRankingResponse(res);
            },
            (err: any) => {
              console.log(err);
              this.ranking = [];
              this.length = 0;
              this.loading = false;
            }
          );
          return;
        }

        this.applyRankingResponse(JSON.parse(cache.data));
      },
      (err: any) => {
        console.log(err);
        this.loading = false;
      }
    );
  }

  applyRankingResponse(res: any) {
    this.rankingEnabled = !!res.enabled;
    this.ranking = (res.items || []).map((item: any, index: number) => {
      item.position = item.rank || ((this.pageIndex * this.pageSize) + index + 1);
      return item;
    });
    this.length = (this.pageIndex * this.pageSize) + this.ranking.length + (res.has_more ? this.pageSize : 0);
    this.loading = false;
  }

  changePeriod(period: string) {
    if (this.selectedPeriod === period) return;
    this.selectedPeriod = period;
    this.pageIndex = 0;
    if (this.paginator) this.paginator.pageIndex = 0;
    this.getRanking();
  }

  cacheName() {
    const userId = (this.user && this.user.id) ? this.user.id : 'user';
    return 'cachedDashboardRanking_' + userId + '_' + this.selectedPeriod + '_' + this.pageSize + '_' + this.pageIndex;
  }

  refreshRanking() {
    this.getRanking(true);
  }

  changePage(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.getRanking(false, event.pageIndex);
  }

  goToStudent(student: any) {
    if (!student || !student.customer_id) return;
    if (this.user && this.user.account_type === 'master') {
      this.router.navigate(['clientes/' + (student.customer_email || student.customer_id)], { skipLocationChange: true });
      return;
    }
    this.router.navigate(['professor/alunos/' + student.customer_id], { skipLocationChange: true });
  }

  studentName(student: any) {
    if (!student || !student.customer_name) return 'Aluno oculto';
    return student.customer_name;
  }

  numberValue(value: any) {
    if (value === null || value === undefined) return '0';
    const numericValue = Number(value);
    if (isNaN(numericValue)) return value;
    return numericValue.toLocaleString('pt-BR', { maximumFractionDigits: 0 });
  }

}
